import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import { getCustomerId, setBranchName, setCustomerMail } from "utility/HeaderConfig";
import { ECommerce } from "api/AppConfigApi";
import { getCustomer } from "api/CustomerApi";
import { getProductStatusData } from "api/ProductApi";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ViewAddress from "./ViewAddress";
import { getCustomerAddress } from "utility/HeaderConfig";

// eslint-disable-next-line
const Heading = tw.h1`text-center`;

export default function ShippingAddress(props) {
  const history = useNavigate();

  const [verifyAmount, setVerifyAmount] = useState(0);
  const [propValueData, setPropVaueData] = useState(props.viewCart);
  const [checkStatus, setCheckStatus] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCheckProductStatus();
    getPriceCheck();
    getCustomerDetails();
    //eslint-disable-next-line
  }, []);

  const getCustomerDetails = () => {
    const response = getCustomer(getCustomerId());
    response.then((data) => {
      setBranchName(data.response.branchName);
      setCustomerMail(data.response.email);
    });
  };

  const getCheckProductStatus = () => {
    propValueData.forEach((element, idx) => {
      const res = getProductStatusData(element.id);
      res.then((data) => {
        if (data.response.length > 0) {
          data.response.forEach((item) => {
            element['statusName'] = item.status
            if (item.status.toLowerCase() === "sold") {

              setCheckStatus(true)
            }
          });
        }
      })
        .catch((err) => {
          console.log(err);
        });
      if (propValueData.length - 1 === idx) {
        setPropVaueData(propValueData);
      }
    });
  };

  const AddressDetails = () => {
    if (props?.total <= verifyAmount) {
      if (checkStatus) {
        toast.error("Please Select Address");
      } else {
        let res = JSON.parse(getCustomerAddress());
        props.onClick(res)
      }
    }
    //  else{
    //   toast.error(`The Purchase Amount Is Shouldn't Be Greater Than ${verifyAmount}`,{
    //     position: "top-right",
    //     duration: 3000,
    //    })
    //  }
  };

  const getPriceCheck = async () => {
    let filter = "sales_threshold";
    let appConfigResData = await ECommerce(filter);
    let appConfigthresholdValue = JSON.parse(
      appConfigResData.response.moduleField
    );
    let saleThresholdValue = 0;
    Object.entries(appConfigthresholdValue).forEach((entry) => {
      if (entry[0] === "sales_threshold_amount") {
        saleThresholdValue = entry[1];
      }
    });
    setVerifyAmount(saleThresholdValue);
  };

  return (
    <>
      <div 
       style={{ 
         height: "100px", borderRadius: "5px", display: "flex", justifyContent: "end",marginLeft:"-400px", marginTop: "50px"
        }}>
        <button type="button" className="btn" onClick={() => { history("/AddAddress") }}
          style={{ background: "#811331", color: "white", height: "40px", marginTop: "-50px" }}>
          <i className="bi bi-plus-lg"></i> New Address
        </button>

      </div>
      <div style={{ marginTop: "-110px" }}>
        <ViewAddress status={setCheckStatus} />
      </div>

      <div className="text-center">
        <button
          className="btn-md btnShop px-3 py-2 "
          onClick={AddressDetails}
          type="button"
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
              ></span>
              <span className="mx-2">Loading . . .</span>
            </>
          ) : (
            <>
              Save & Continue
            </>
          )}
        </button>
      </div>

    </>
  );
}
